import React from 'react';

import * as FPAIConstants from './constants';
import * as D from './deps';
import FPAIReducer from './reducer';
import FPAISagas from './sagas/watchers';
import * as FPAISelectors from './selectors';

export default D.createDomainModule({
  name: FPAIConstants.DOMAIN_NAME,
  components: {
    ProcessFamilyPlanAcceptInvite: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_familyPlanAcceptInvite_process-family-plan-accept-invite" */ './components/ProcessFamilyPlanAcceptInvite/ProcessFamilyPlanAcceptInvite',
            )
          }
        />
      );
    },
  },
  reducer: FPAIReducer,
  selectors: {
    _familyPlanAcceptInvite_: {
      isInFamilyPlanInviteeFlow: FPAISelectors.isInFamilyPlanInviteeFlow,
    },
  },
  onStart() {
    this.registeredHandlers = D.registerHandlers(FPAISagas);
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});
